import { AXIOS } from "../customAxios";

export async function getCountryCodes() {
  return await AXIOS.get(`/api/master/fetchCountryCodes`, {
    headers: {
      clientId: "-1"
    },
  });
}
